import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import { IAuthContext } from "./IAuthContext";

export  const useRadacadAuth = ():IAuthContext => useContext<IAuthContext>(AuthContext);